import React from 'react'
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

const Cardpartners = () => {
    const { t } = useTranslation();
    return (
        <>
            <NavLink to={t('url.poslovnipartnerji')} className='card-link'>
                <div className="card">
                    <img src={`${process.env.PUBLIC_URL}/images/cards/product-partners.png`} alt="Partnerji in investitorji" />
                    <div className="card-text">
                        <h3>{t('partners.investors')}</h3>
                    </div>
                    <div className="readmore">
                        <NavLink to={t('url.poslovnipartnerji')}>{t('products.readmore')}</NavLink>
                    </div>
                </div>
            </NavLink>
            <div className="card-shadow">
                <img src={`${process.env.PUBLIC_URL}/images/cards/shadow.png`} alt="shadow card" />
            </div>
        </>
    )
}

export default Cardpartners